import React from "react";
import { useTranslation } from "react-i18next";

const LanguageTitle = ({ element }: { element: any }) => {
  const { i18n } = useTranslation();
  return <>{element.title[i18n.language] || element.code}</>;
};

export default LanguageTitle;
